import { Component, Inject, ViewContainerRef, TemplateRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { PagerService } from '../../services/shared/pager.service';
import { Payment } from '../../models/payment/payment-model';
import { PaymentService } from '../../services/payment/payment.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-payment-method-list',
    templateUrl: './payment-method-list.component.html',
    styleUrls: ['./payment-method-list.component.css']
})
/** payment-method-list component*/
export class PaymentMethodListComponent {
  /** subscriber-list ctor */
  public paymentList: Payment[];
  // pager object
  searchKeyword: string;
  // paged items
  filteredItems: any[];
  isActive: string;
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** subscriber-list ctor */
  constructor(private readonly paymentService: PaymentService, private readonly pagerService: PagerService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly utilitiesService: UtilitiesService,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("paymentmethod").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.toastr.setRootViewContainerRef(vcr);
          this.getpaymentmethods();
          this.isActive = "";
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )

  } 
  getpaymentmethods() {
    this.paymentService.getPaymentMethods().subscribe(
      data => {
        this.paymentList = data;
        this.filteredItems = data;
      }
    )
  }
  deletePaymentMethod(id) {
    if (confirm("Are you sure to delete this payment method ?")) {
      this.paymentService.deletePaymentMethod(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Payment Method has been Deleted.', 'Success');
            setTimeout(() => {
              this.getpaymentmethods();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Error');
          }
        }
      )
    }
  }
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  OnFilterChange() {
    this.filteredItems = this.paymentList;

    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    } else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }



  }

}




// WEBPACK FOOTER //
// ./src/app/payment-components/payment-method-list/payment-method-list.component.ts